<template>
  <v-app id="app">
    <AppsModal />
    <MediaLightBox />
    <VideoLightbox />
    <keep-alive include="MapboxView">
      <router-view :key="$route.fullPath" />
    </keep-alive>
  </v-app>
</template>

<script>
import AppsModal from "@/components/AppsModal.vue";
import MediaLightBox from "@/components/MediaLightBox.vue";
import VideoLightbox from "@/components/VideoLightbox.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AppsModal,
    MediaLightBox,
    VideoLightbox
  },
  computed: {
    ...mapGetters(["getAppId"])
  },
  watch: {
    $route: {
      immediate: true,
      handler: function() {
        const title = this.getAppTitle();
        document.title = title;
      }
    }
  },
  methods: {
    getAppTitle() {
      if (this.getAppId == 1) return "Huygens’ Tijdmachine";
      if (this.getAppId == 2) return "Dordrecht5D";
      if (this.getAppId == 3) return "Canals5D";
    }
  }
};
</script>

<style lang="scss">
.slide-right-leave-active,
.slide-right-enter-active {
  transition: 1s;
}

.slide-right-enter {
  transform: translate(100%, 0);
}

.slide-right-leave-to {
  transform: translate(-100%, 0);
}
</style>
